export default __webpack_public_path__ + "static/media/AlgoAppResponsiveSmall.eb8288d2.png";